import {
  ADD_FEED,
  ADD_FEED_FAILURE,
  ADD_FEED_SUCCESS,
  //
  DELETE_FEED,
  DELETE_FEED_FAILURE,
  DELETE_FEED_SUCCESS,
  //
  EDIT_FEED,
  EDIT_FEED_FAILURE,
  EDIT_FEED_SUCCESS,
  //
  FETCH_FEEDS,
  FETCH_FEEDS_FAILURE,
  FETCH_FEEDS_SUCCESS,
  GET_FEED_STATS,
  GET_FEED_STATS_FAILURE,
  GET_FEED_STATS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_FEED_ADD_MODAL,
  SET_FEED_FILTER,
  //
  UPDATE_FORM_VALUES,
  UPDATE_MEDIA_FILES,
  RESET_FORM_VALUES,
  //
  TOGGLE_DELETE,
  //
  ADD_VOTE,
  ADD_VOTE_SUCCESS,
  ADD_VOTE_FAILURE,
  ADD_EVENT_RSVP,
  ADD_EVENT_RSVP_SUCCESS,
  ADD_EVENT_RSVP_FAILURE,
} from "./constants";

// List
export const fetchFeeds = (payload) => ({
  type: FETCH_FEEDS,
  payload,
});
export const fetchFeedsSuccess = (payload) => ({
  type: FETCH_FEEDS_SUCCESS,
  payload,
});
export const fetchFeedsFailure = (payload) => ({
  type: FETCH_FEEDS_FAILURE,
  payload,
});

export const getFeedStats = () => ({
  type: GET_FEED_STATS,
});
export const getFeedStatsSuccess = (payload) => ({
  type: GET_FEED_STATS_SUCCESS,
  payload,
});
export const getFeedStatsFailure = (payload) => ({
  type: GET_FEED_STATS_FAILURE,
  payload,
});

// View
export const getViewData = (payload, onSuccess) => ({
  type: GET_VIEW_DATA,
  payload,
  onSuccess,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addFeed = (payload, onSuccess) => ({
  type: ADD_FEED,
  payload,
  onSuccess,
});
export const addFeedSuccess = (payload) => ({
  type: ADD_FEED_SUCCESS,
  payload,
});
export const addFeedFailure = (payload) => ({
  type: ADD_FEED_FAILURE,
  payload,
});
// EDIT
export const editFeed = (payload, onSuccess) => ({
  type: EDIT_FEED,
  payload,
  onSuccess,
});
export const editFeedSuccess = (payload) => ({
  type: EDIT_FEED_SUCCESS,
  payload,
});
export const editFeedFailure = (payload) => ({
  type: EDIT_FEED_FAILURE,
  payload,
});
// DELETE
export const deleteFeed = (payload, onDelete) => ({
  type: DELETE_FEED,
  payload,
  onDelete,
});
export const deleteFeedSuccess = (payload) => ({
  type: DELETE_FEED_SUCCESS,
  payload,
});
export const deleteFeedFailure = (payload) => ({
  type: DELETE_FEED_FAILURE,
  payload,
});

export const toggleFeedAddModal = (payload) => ({
  type: TOGGLE_FEED_ADD_MODAL,
  payload,
});

export const setFeedFilter = (payload) => ({
  type: SET_FEED_FILTER,
  payload,
});

export const updateFormValues = (payload) => ({
  type: UPDATE_FORM_VALUES,
  payload,
});
export const updateMediaFiles = (payload) => ({
  type: UPDATE_MEDIA_FILES,
  payload,
});

export const resetFormValues = () => ({
  type: RESET_FORM_VALUES,
});

export const toggleDelete = (payload) => ({
  type: TOGGLE_DELETE,
  payload,
});

export const addVote = (payload, onSuccess) => ({
  type: ADD_VOTE,
  payload,
  onSuccess,
});
export const addVoteSuccess = (payload) => ({
  type: ADD_VOTE_SUCCESS,
  payload,
});
export const addVoteFailure = (payload) => ({
  type: ADD_VOTE_FAILURE,
  payload,
});

export const addEventRsvp = (payload, onSuccess, onError) => ({
  type: ADD_EVENT_RSVP,
  payload,
  onSuccess,
  onError,
});

export const addEventRsvpSuccess = (payload) => ({
  type: ADD_EVENT_RSVP_SUCCESS,
  payload,
});

export const addEventRsvpFailure = (payload) => ({
  type: ADD_EVENT_RSVP_FAILURE,
  payload,
});
